import { render, staticRenderFns } from "./SplitRuleDetailManage.vue?vue&type=template&id=3e1e3e28&scoped=true"
import script from "./SplitRuleDetailManage.vue?vue&type=script&lang=js"
export * from "./SplitRuleDetailManage.vue?vue&type=script&lang=js"
import style0 from "./SplitRuleDetailManage.vue?vue&type=style&index=0&id=3e1e3e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1e3e28",
  null
  
)

export default component.exports